import React from "react";
import { Menu, Space } from "antd";
import type { SourceFilter, SourceHierarchy } from "../../../../../../core/data/redux/leads-queue/types";

interface FacebookMenuProps {
    sourceHierarchy: SourceHierarchy | null;
    activeFilter: SourceFilter;
    onChange: (filter: SourceFilter) => void;
}

const FacebookMenu: React.FC<FacebookMenuProps> = ({ sourceHierarchy, activeFilter, onChange }) => {
    if (!sourceHierarchy?.facebook) return null;

    const { facebook } = sourceHierarchy;

    const handleFilterChange = (level1: string | null, level2: string | null, level3: string | null) => {
        onChange({ level_1: level1, level_2: level2, level_3: level3 });
    };

    const isActive = (level1?: string, level2?: string, level3?: string) => {
        if (!level1 && !level2 && !level3) {
            return !activeFilter.level_1 && !activeFilter.level_2 && !activeFilter.level_3;
        }
        return (
            String(activeFilter.level_1) === String(level1) &&
            String(activeFilter.level_2) === String(level2) &&
            String(activeFilter.level_3) === String(level3)
        );
    };

    const getActiveFormName = () => {
        if (!activeFilter.level_1 || !activeFilter.level_2 || !activeFilter.level_3) return null;

        for (const app of facebook) {
            if (String(app.app_id) === String(activeFilter.level_1)) {
                for (const page of app.pages) {
                    if (String(page.page_id) === String(activeFilter.level_2)) {
                        const form = page.forms.find((f: any) => String(f.form_id) === String(activeFilter.level_3));
                        if (form) {
                            return `${app.app_name} > ${page.page_name} > ${form.form_name}`;
                        }
                    }
                }
            }
        }
        return null;
    };

    const activeFormName = getActiveFormName();

    return (
        <Menu mode="inline">
            {activeFormName && (
                <>
                    <Menu.Item
                        key="active-filter"
                        disabled
                        style={{
                            backgroundColor: "#e6f7ff",
                            fontWeight: 600,
                            cursor: "default",
                            color: "#1890ff",
                        }}
                    >
                        <Space>
                            <i className="ti ti-filter" style={{ color: "#1890ff" }} />
                            <span>Active: {activeFormName}</span>
                        </Space>
                    </Menu.Item>
                    <Menu.Divider />
                </>
            )}

            <Menu.Item
                key="all"
                onClick={() => handleFilterChange(null, null, null)}
                style={isActive() ? { backgroundColor: "#f0f0f0", fontWeight: 500 } : {}}
            >
                <Space>
                    <i className="ti ti-list" />
                    <span>All Facebook Leads</span>
                </Space>
            </Menu.Item>

            <Menu.Divider />

            {facebook.map((app: any) => (
                <Menu.SubMenu
                    key={String(app.app_id)}
                    title={
                        <Space>
                            <i className="ti ti-app-window" />
                            <span>{app.app_name}</span>
                        </Space>
                    }
                >
                    {app.pages.map((page: any) => (
                        <Menu.SubMenu
                            key={String(page.page_id)}
                            title={
                                <Space>
                                    <i className="ti ti-brand-facebook" />
                                    <span>{page.page_name}</span>
                                </Space>
                            }
                        >
                            {page.forms.map((form: any) => (
                                <Menu.Item
                                    key={String(form.form_id)}
                                    onClick={() => handleFilterChange(String(app.app_id), String(page.page_id), String(form.form_id))}
                                    style={
                                        isActive(String(app.app_id), String(page.page_id), String(form.form_id))
                                            ? { backgroundColor: "#e6f7ff", fontWeight: 500 }
                                            : {}
                                    }
                                >
                                    <Space>
                                        <i className="ti ti-forms" />
                                        <span>{form.form_name}</span>
                                    </Space>
                                </Menu.Item>
                            ))}
                        </Menu.SubMenu>
                    ))}
                </Menu.SubMenu>
            ))}
        </Menu>
    );
};

export default FacebookMenu;
